<template>
  <div class="noticelist">
    <!-- <div class="noticelist-pic" /> -->
    <!-- <TitlePic imgSrc="noticelist_sp.png" /> -->
    <v-img class="noticelist-pic" :src="require('../assets/img/noticelist_sp.png')" />

    <div v-for="data in getNoticeList" :key="data.id">
      <NoticeDetail :data="data" @clickSentence="clickSentence" />
    </div>

    <NoticeCentence :selectedNotice="selectedNotice" @clickClose="closeNoticeCentence" />

    <!-- <div v-if="selectedNotice">
      <div class="notice-sentence">
        <div class="notice-sentence-black" />
        <div class="notice-sentence-frame">
          <div class="notice-sentence-upper">
            <div class="notice-sentence-date">{{ selectedNotice.date }}</div>
            &nbsp;
            <div class="notice-sentence-name">{{ selectedNotice.name }}</div>
          </div>
          <div class="notice-sentence-line" />
          <div class="notice-sentence-under">
            <div class="notice-sentence-detail">{{ selectedNotice.detail }}</div>
          </div>
        </div>
        <div class="notice-sentence-button">
          <Button text="とじる" @click="clickClose()" />
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import NoticeDetail from '@/components/NoticeDetail';
import NoticeCentence from '../components/NoticeSentence.vue';

export default {
  name: 'NoticeList',
  components: {
    NoticeDetail,
    NoticeCentence
  },
  data() {
    return {
      detailTitle: '',
      detailText: '',
      selectedNotice: null
    };
  },
  computed: {
    ...mapState('notice', ['noticeList']),
    isScreenSmAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    getNoticeList() {
      return this.noticeList;
    }
  },
  methods: {
    clickSentence(data) {
      this.selectedNotice = data;
    },
    closeNoticeCentence() {
      this.selectedNotice = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.noticelist {
  background-color: #fce8a8;
  padding: 20px;
  padding-top: 80px;

  &-pic {
    height: 51px;
    max-width: 340px;
    margin: 0 auto;
  }
}
</style>
